import { Reveal } from "../lib/motion";
import { SERVICES } from "../lib/data";
import { ArrowUpRight } from "lucide-react";
import { LocalImage } from "./LocalImage";

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-20 md:py-28 lg:py-36 bg-brand-dark">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand mb-4 flex items-center gap-3">
          <span className="w-8 h-px bg-brand" /> Unsere Services
        </p>
        <h2 className="section-heading max-w-3xl">
          Lösungen für jede Anforderung
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-12 gap-5 mt-10 md:mt-14">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 2) * 0.1} className={s.span}>
            <a href="#kontakt" data-testid={`service-card-${i}`}
               className="service-card group relative flex min-h-[400px] lg:min-h-[440px] h-full overflow-hidden border border-slate-800 hover:border-brand/50 transition-colors">
              <LocalImage src={s.img} alt={s.alt} width={1152} height={2048} style={{ objectPosition: s.position }}
                   className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/80 to-brand-dark/10" />
              <div className="relative w-full flex flex-col justify-end p-6 lg:p-8 pt-32">
                <span className="font-mono text-[11px] uppercase tracking-widest text-brand mb-3">{s.tag}</span>
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-display font-bold text-xl lg:text-2xl text-white leading-snug [overflow-wrap:anywhere]">{s.title}</h3>
                  <ArrowUpRight className="text-white/40 group-hover:text-brand group-hover:translate-x-1 group-hover:-translate-y-1 transition-all shrink-0" />
                </div>
                <p className="text-white/70 text-sm mt-3 max-w-md leading-relaxed">{s.desc}</p>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
